import { useEffect, useState } from "react";

const THRESHOLDS = [
  { value: "moderate", label: "Moderate and above" },
  { value: "elevated", label: "Elevated and above" },
  { value: "high", label: "High only" },
];

const SUMMARY_OPTIONS = [
  { value: "none", label: "No periodic summary" },
  { value: "daily", label: "Daily summary (neighborhood)" },
  { value: "weekly", label: "Weekly summary (neighborhood)" },
];

export default function WeatherWatchSettingsModal({
  open,
  initialValues,
  onClose,
  onSave,
  saving = false,
}) {
  const [form, setForm] = useState(initialValues || {});

  useEffect(() => {
    if (open) {
      setForm(initialValues || {});
    }
  }, [open, initialValues]);

  if (!open) {
    return null;
  }

  return (
    <div className="weather-watch-modal" role="dialog" aria-modal="true" aria-labelledby="weather-watch-title">
      <div className="weather-watch-modal__backdrop" onClick={onClose} aria-hidden="true" />
      <div className="weather-watch-modal__panel">
        <header className="weather-watch-modal__header">
          <h3 id="weather-watch-title">Weather watch settings</h3>
          <button type="button" className="weather-watch-modal__close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </header>

        <p className="muted">
          Monitor this place for changing weather-risk signals. This is decision-support, not an official
          emergency alert service.
        </p>

        <label className="weather-watch-modal__field">
          <span>Alert when risk reaches</span>
          <select
            value={form.riskThreshold || "elevated"}
            onChange={(event) => setForm((current) => ({ ...current, riskThreshold: event.target.value }))}
          >
            {THRESHOLDS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>

        <fieldset className="weather-watch-modal__fieldset">
          <legend>Notify me when</legend>
          <label>
            <input
              type="checkbox"
              checked={form.alertOnRiskIncrease !== false}
              onChange={(event) =>
                setForm((current) => ({ ...current, alertOnRiskIncrease: event.target.checked }))
              }
            />
            Risk level increases
          </label>
          <label>
            <input
              type="checkbox"
              checked={form.alertOnOfficialAlert !== false}
              onChange={(event) =>
                setForm((current) => ({ ...current, alertOnOfficialAlert: event.target.checked }))
              }
            />
            Official alert appears nearby
          </label>
          <label>
            <input
              type="checkbox"
              checked={form.alertOnQuebradaElevated !== false}
              onChange={(event) =>
                setForm((current) => ({ ...current, alertOnQuebradaElevated: event.target.checked }))
              }
            />
            Nearby quebrada level is elevated
          </label>
          <label>
            <input
              type="checkbox"
              checked={form.alertOnHeavyRain !== false}
              onChange={(event) =>
                setForm((current) => ({ ...current, alertOnHeavyRain: event.target.checked }))
              }
            />
            Heavy rain nearby
          </label>
          <label>
            <input
              type="checkbox"
              checked={form.alertOnSourceDown === true}
              onChange={(event) =>
                setForm((current) => ({ ...current, alertOnSourceDown: event.target.checked }))
              }
            />
            Weather sources are degraded
          </label>
        </fieldset>

        <label className="weather-watch-modal__field">
          <span>Summary frequency</span>
          <select
            value={form.summaryFrequency || "none"}
            onChange={(event) =>
              setForm((current) => ({ ...current, summaryFrequency: event.target.value }))
            }
          >
            {SUMMARY_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>

        <footer className="weather-watch-modal__footer">
          <button type="button" className="weather-btn weather-btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="weather-btn weather-btn-primary"
            disabled={saving}
            onClick={() => onSave?.(form)}
          >
            {saving ? "Saving…" : "Save watch"}
          </button>
        </footer>
      </div>
    </div>
  );
}
